<div class="common-wrapper">
    <div class="main-hd-txt">
        <h4>
            <pageheader [entity]="headerDelegate"></pageheader>
        </h4>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="Delegate" [actionExclude]="['feedback','column']" [checkboxCol]="true"
        [entityColumns]="DelegateColumns" [selectionField]="'Delegation_Id'" [addEntityIcon]="'bi bi-plus-square'"
        [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (addEntity)="addDelegate($event)"
        (downloadEntities)="onExcelExport()" (editEntity)="editDelegate($event)"
        (refreshEntities)="refreshDelegate($event)" (deleteEntity)="deleteDelegate($event)" 
        (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
        [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)" >
    </grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearDelegate()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Delegate Name'" [formData]="entity" [maxlength]="50" [mandatory]="true"
                    [fieldName]="'DelegationName'" [(ngModel)]="entity.DelegationName " ngDefaultControl>
                </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Description'" [multiline]="true" [formData]="entity" [maxlength]="500"  
                    [fieldName]="'DelegationDescription'" [(ngModel)]="entity.DelegationDescription"  ngDefaultControl>
                </textbox>
                </div>
            </div>
           
           
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div>
        </div>
       
    </div>
</div>

<kendo-excelexport [data]="Delegate.data" [collapsible]="true" fileName="DelegationMaster.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DelegationName" title="DelegateName" [width]="200">
    </kendo-excelexport-column>  
    <kendo-excelexport-column field="DelegationDescription" title="DelegateDescription" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 

</kendo-excelexport>